import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import styles from '../../../constants/styles'
import * as actions from '../../../actions'

class HasAccount extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.containerRef = null
  }

  render() {
    const { setNextStep } = this.props
    return (
      <Container>
        <Question> Do you have an existing abillion account? </Question>
        <ButtonsContainer>
          <Button
            onClick={() => {
              setNextStep('login')
            }}
          >
            Yes
          </Button>
          <Button
            onClick={() => {
              setNextStep('signup')
            }}
          >
            No
          </Button>
        </ButtonsContainer>
      </Container>
    )
  }
}

HasAccount.propTypes = {
  setNextStep: PropTypes.func.isRequired
}

const mapDispatchToProps = (dispatch) => ({
  setNextStep: (step) => {
    dispatch({ type: actions.SET_NEXT_STEP, step })
  }
})

export default connect(null, mapDispatchToProps)(HasAccount)

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: ${styles.margin.large};
`
const SubTitle = styled.h2`
  color: ${styles.colors.grey};
  text-align: center;
  font-size: 1.2em;
`
const Question = styled(SubTitle)`
  margin-top: ${styles.margin.large};
  font-weight: 600;
  text-align: center;
  color: ${styles.colors.black};
`
const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: ${styles.margin.medium};
`
const Button = styled.button`
  padding: 4px 0;
  width: 120px;
  color: ${styles.colors.black};
  background-color: ${styles.colors.white};
  border: 2px solid #7500cb;
  margin: ${styles.margin.small};
  border-radius: 24px;
  cursor: pointer;
  font-size: 1em;

  &:hover {
    background-color: #7500cb;
    color: ${styles.colors.white};
    border: 2px solid ${styles.colors.white};
  }
`
